import API from '@Services/apiAxios';

export interface ExtractionResponse {
  message?: string;
  state?: string;
  [key: string]: any;
}

export const extractDocument = async (
  s3Key: string,
  documentType = 'shipment',
  orgCode?: string,
  sessionId?: string,
): Promise<ExtractionResponse> => {
  const requestHeaders: Record<string, string> = {};
  if (orgCode) {
    requestHeaders['org_code'] = orgCode;
  }
  if (sessionId) {
    requestHeaders['sessionId'] = sessionId;
  }

  const response = await API.post<ExtractionResponse>(
    '/speedboxbot/extract',
    {
      documentType,
      s3Key,
    },
    {
      headers: requestHeaders,
    },
  );
  return response.data;
};
